import { Link, useNavigate } from 'react-router-dom';
import { useSession } from '../lib/session';
import { ADMIN_ROLES } from '../api/enums';
import { Alert, Card, Spinner } from '../components/ui';
import { useT } from '../i18n/locale';

/** Database picker, replacing the three hardcoded company cards. */
export default function HomeScreen() {
  const t = useT();
  const { databases, loading, selectDatabase, user } = useSession();
  const navigate = useNavigate();

  if (loading) return <Spinner label={t('common.loading')} />;

  if (databases.length === 0) {
    return (
      <div className="mx-auto max-w-2xl p-6">
        <Alert tone="info">
          {t('home.noDatabase')}{' '}
          {user !== null && ADMIN_ROLES.includes(user.role) ? (
            <>
              {t('home.openSettingsPre')}
              <Link to="/settings/accurate" className="font-bold underline">
                {t('home.settingsLink')}
              </Link>
              {t('home.openSettingsPost')}
            </>
          ) : (
            t('home.askAdminConnect')
          )}
        </Alert>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-5xl p-4">
      <h2 className="mb-4 text-lg font-bold text-white">{t('home.pickDatabase')}</h2>
      <div className="grid gap-4 md:grid-cols-3">
        {databases.map((db) => (
          <button
            key={db.id}
            onClick={() => {
              selectDatabase(db.id);
              navigate(`/db/${db.id}`);
            }}
            className="cursor-pointer border-0 bg-transparent p-0 text-left"
          >
            <Card className="flex min-h-40 flex-col items-center justify-center p-6 transition-all hover:-translate-y-1 hover:border-brand-500 hover:shadow-lg">
              <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-brand-50 text-2xl text-brand-500">
                ▦
              </div>
              <h3 className="m-0 text-center text-base font-bold text-slate-800">{db.alias}</h3>
              {/*
                A disconnected database is still listed, because its receiving
                history is still a record somebody may need. Saying so here is
                the difference between "kept" and "reachable".
              */}
              {!db.isConnected ? (
                <p className="mt-2 m-0 text-center text-[11px] font-semibold text-slate-500">
                  {t('home.historyOnly')}
                </p>
              ) : db.lastError ? (
                <p className="mt-2 m-0 text-center text-[11px] font-semibold text-red-600">
                  {t('home.connectionProblem')}
                </p>
              ) : null}
            </Card>
          </button>
        ))}
      </div>
    </div>
  );
}
